import Loading from "../Loading";

interface Props {
  title?: string;
  description?: string | React.ReactNode;
  blurryBackground?: boolean;
  width?: number;
  height?: number;
}

const FullScreenLoading: React.FC<Props> = ({
  title,
  description,
  blurryBackground = true,
  width = 125,
  height = 125,
}) => {
  return (
    <div
      className={`flex flex-col justify-center items-center overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none ${
        blurryBackground ? "bg-zinc-800 bg-opacity-70 backdrop-blur-sm" : "bg-body"
      }`}
    >
      <Loading width={width} height={height} />
      <div className="flex flex-col text-center itens-center text-white font-dmSans">
        <h3 className="text-2xl">{title}</h3>
        <p className="text-lg mt-4">{description}</p>
      </div>
    </div>
  );
};

export default FullScreenLoading;
